import api from "../../http";

export default class ApiAboutOurGoal {
  static async getApiAboutOurGoal(url) {
    return api.get(url)
  }
}